import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private apiUrl = environment.api;
  private apiWaderlust = environment.apiWaderlust;
  private headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${environment.token}`
  }


  constructor(private http: HttpClient) { }

  get<T>(endpoint: string, params?: any, headers?: any): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/${endpoint}`, { params, headers });
  }
  getWaderlust<T>(endpoint: string, params?: any): Observable<T> {
    return this.http.get<T>(`${this.apiWaderlust}/${endpoint}`, { params, headers: this.headers });
  }

  async listarCiudades_Paises() {
    const info = await fetch(`${environment.apiWaderlust}/iata/cities-by-country`, {
      method: 'GET',
      headers: this.headers
    })
      .then(response => response.json())
      .then(data => {
        const datos = data?.data.flatMap((item: any) => {
          return Object.entries(item).map(([pais, ciudades]) => ({
            pais,
            ciudades
          }));
        });
        return datos;
      })
      .catch(error => {
        console.error('Error fetching cities:', error);
      });

    return info;

  }


  async ListaDePaises() {
    const info = await fetch(`${environment.apiWaderlust}/locations/countries`, {
      method: 'GET',
      headers: this.headers
    })
      .then(response => response.json())
      .then(data => {
        const datos = data?.response;
        return datos;
      }
      )
      .catch(error => {
        console.error('Error fetching cities:', error);
      });
      
    return info;
  }

  async buscarHotelesPorita(consulta: string) {
    console.log('Consulta IATA:', consulta);
    const info = await fetch(`${environment.apiWaderlust}/hotels/iata/${consulta}`, {
      method: 'GET',
      headers: this.headers
    })
      .then(response => response.json())
      .then(data => {
        console.log('Datos de hoteles recibidos:', data);
        // const datos = data?.data.flatMap((item: any) => {
        //   return Object.entries(item).map(([pais, ciudades]) => ({
        //     pais,
        //     ciudades
        //   }));
        // });
        return data;
      })
      .catch(error => {
        console.error('Error fetching cities:', error);
      });

    return info;

  }

  async obtenerCiudadesPorPais(id: number) {
    const info = await fetch(`${environment.apiWaderlust}/locations/countries/${id}/cities`, {
      method: 'GET',
      headers: this.headers
    })
      .then(response => response.json())
      .then(data => {
        const datos = data?.response;
        return datos.cities;
      })
      .catch(error => {
        console.error('Error fetching cities:', error);
      });
      
    return info;
  }

  async searchCities(query: string) {
    const info = await fetch(`${environment.apiWaderlust}/locations/cities/search?name=${encodeURIComponent(query)}`, {
      method: 'GET',
      headers: this.headers
    })
      .then(response => response.json())
      .then(data => {
        return data?.response || [];
      })
      .catch(error => {
        console.error('Error searching cities:', error);
        return [];
      });
    return info;
  }

  async obtenerHotelesPorCiudad(id: any) {
    try {
      const response = await fetch(`${environment.apiWaderlust}/hotels/city/${id}`, {
        method: 'GET',
        headers: this.headers
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status} al consultar hoteles por ciudad ${id}`);
      }

      const data = await response.json();
      console.log('Datos de hoteles recibidos:', data);
      return data;
    } catch (error) {
      console.error('Error fetching hotels by city:', error);
      throw error;
    }
  }


  misVaijes(): Observable<any> {
    return this.get('/usuario/viajes')
  }

  post<T>(endpoint: string, data: any, headers?: any): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}/${endpoint}`, data, { headers });
  }

  put<T>(endpoint: string, data: any, headers?: any): Observable<T> {
    return this.http.put<T>(`${this.apiUrl}/${endpoint}`, data, { headers });
  }

  patch<T>(endpoint: string, data: any, headers?: any): Observable<T> {
    return this.http.patch<T>(`${this.apiUrl}/${endpoint}`, data, { headers });
  }

  delete<T>(endpoint: string, params?: any, headers?: any): Observable<T> {
    return this.http.delete<T>(`${this.apiUrl}/${endpoint}`, { params, headers });
  }
}
